function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 180.872,
  cy: 328.665,
  rx: 29.099,
  ry: 59.374,
  fill: "#e6e6e6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M183.56 425.851c-11.655-69.925-.118-139.598 0-140.293l2.267.384c-.117.692-11.588 69.999 0 139.532z",
  fill: "#3f3d56"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M180.177 329.972l26.314-14.074 1.085 2.028-26.314 14.075zM152.406 324.975l1.085-2.027 26.31 14.082-1.085 2.028zM720.059 3.963h47.694v165.095h-47.694z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M799.25 138l-116-138-232.846 2.129-141.248 137.578 2.854 1.835h-1.019v286.164h487.946V141.542l.313-3.542z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7ebc89",
  d: "M683.371.294L538.455 170.193v257.513h260.482V137.873L683.371.294z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M643.015 285.298h53.197v47.02h-53.197zM643.015 203.911h53.197v46.275h-53.197z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M643.015 285.298h53.197v47.02h-53.197zM643.015 203.911h53.197v46.275h-53.197z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M502.33 419.315s1.14-23.896 24.519-21.118",
  fill: "#e6e6e6"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 495.724,
  cy: 384.874,
  r: 11.701,
  fill: "#7ebc89"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M493.82 404.578h3.303v23.12h-3.303z"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 110.955,
  cy: 237.096,
  rx: 56.915,
  ry: 116.129,
  fill: "#7ebc89"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M117.295 427.001c-22.765-136.585-.23-272.673 0-274.032l2.267.384c-.23 1.356-22.698 137.077 0 273.27z",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M110.115 240.623l51.468-27.53 1.084 2.028-51.468 27.53zM55.797 228.912l1.086-2.028 51.46 27.544-1.085 2.027z"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 245.754,
  cy: 167.201,
  rx: 77.883,
  ry: 158.914,
  fill: "#7ebc89"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M254.847 427.001c-31.14-186.837-.315-372.992 0-374.85l2.267.384c-.314 1.854-31.073 187.643 0 374.089z",
  fill: "#3f3d56"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M244.804 172.4l70.429-37.672 1.084 2.028-70.429 37.672zM170.474 155.628l1.085-2.028 70.42 37.69-1.086 2.028zM0 425.813h840.5v2H0zM406.602 272.821h53.197v47.02h-53.197zM406.602 191.434h53.197v46.275h-53.197z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M406.602 272.821h53.197v47.02h-53.197zM406.602 191.434h53.197v46.275h-53.197z"
});

function SvgStandardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 840.5,
    height: 427.813
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

export default "data:image/svg+xml;base64,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";
export { SvgStandardIcon as ReactComponent };